module.exports = __webpack_public_path__ + "img/world-2.2f6b642f.png";